import Icon from "assets/icons";
import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";
import Variant from "shared/enums/Variant";
import React from "react";
import classNames from "classnames";

export default function AddMoreButton(props: {
  hasSeperator?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  label?: string;
  btnLabel?: string;
  inline?: boolean;
  isOutlined?: boolean;
}) {
  const copies = useCopies();
  return (
    <React.Fragment>
      <div className={classNames("addMore", props.inline && "inline", props.isOutlined && "isOutlined")}>
        {props.label && <p className="addMore--label">{props.label}</p>}
        <div className="addMore--wrapper">
          {props.hasSeperator && <span className="fullwidthBorder--dashed" />}
          <Button
            className="addMore--button"
            variant={Variant.LINK}
            onClick={props.onClick}
            disabled={props.disabled}
            label={props.btnLabel ? props.btnLabel : copies.get("add")}
            icon={<Icon.AddCircle />}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
